import { Button } from 'react-bootstrap';

const SupplierProfileBuilderCountryBadge: React.FC<{
  countryId: string;
  countryName: string;
  removeCountry: (id: string) => void;
}> = ({ countryId, countryName, removeCountry }) => {
  return (
    <div
      key={countryId}
      className="badge bg-light text-dark border px-3 d-flex align-items-center"
    >
      {countryName || countryId}
      <Button
        variant="link"
        size="sm"
        className="text-danger ms-2 p-0"
        onClick={() => removeCountry(countryId)}
      >
        <i className="bi bi-x-lg"></i>
      </Button>
    </div>
  );
};

export default SupplierProfileBuilderCountryBadge;
